import styled from "styled-components";

import type { elevation } from "@similarweb/styles";
import { colorsPalettes, setElevation } from "@similarweb/styles";
import type { FlexProps } from "@similarweb/ui-components/foundations";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { fadeInUp } from "app/pages/digital-marketing/monitor-and-protect/shared/fade-in-up";

interface IBaseWidgetProps extends FlexProps {
    delay?: string;
    elevation?: keyof typeof elevation | null;
}

export const BaseWidget = styled(Flex)<IBaseWidgetProps>`
    border-radius: 6px;
    ${({ elevation }) => (elevation === null ? "" : setElevation(elevation || "Z1"))};
    background-color: white;
    border: 1px solid ${colorsPalettes.carbon["50"]};

    animation: ${fadeInUp} 0.6s ease-out forwards;
    animation-delay: ${({ delay = "0ms" }) => delay || "0ms"};
    opacity: 0;
`;

export const WidgetMainText = styled(Text)`
    && {
        font-size: 13px;
    }
`;
